module.exports = __webpack_public_path__ + "media/images/flags/sk-5ff847c7df012c7df060120d157240ab.svg";